import React from 'react'

const defaultState = {
  dark: false,
  playing: false,
  putPlayerInBottom: false,
  episode: {},
}

const SiteContext = React.createContext(defaultState)

class SiteProvider extends React.Component {
  state = {
    ...defaultState,
  }

  toggleDark = isDark => {
    if (isDark !== this.state.dark) {
      localStorage.setItem('dark', JSON.stringify(isDark))
      this.setState({ dark: isDark })
    }
  }

  savePlayingState = playing => {
    if (playing !== this.state.playing) {
      this.setState({ playing: playing })
    }
  }

  togglePlayerInBottom = putPlayerInBottom => {
    if (putPlayerInBottom !== this.state.putPlayerInBottom) {
      this.setState({ putPlayerInBottom: putPlayerInBottom })
    }
  }

  saveEpisodePlayed = episode => {
    this.setState({ episode: episode })
  }

  componentDidMount() {
    const lsdark = JSON.parse(localStorage.getItem('dark'))

    if (lsdark) {
      this.setState({ dark: lsdark })
    }
  }

  render() {
    const { children } = this.props
    const { dark, playing, putPlayerInBottom, episode } = this.state
    return (
      <SiteContext.Provider
        value={{
          dark,
          playing,
          putPlayerInBottom,
          episode,
          toggleDark: this.toggleDark,
          savePlayingState: this.savePlayingState,
          togglePlayerInBottom: this.togglePlayerInBottom,
          saveEpisodePlayed: this.saveEpisodePlayed,
        }}>
        {children}
      </SiteContext.Provider>
    )
  }
}

export default SiteContext
export { SiteProvider }
